/**
 * POP3D — the agency's own demo brand (default / showcase).
 * Abstract "products" used when showing the template engine itself.
 */
export const brand = {
  name: 'POP3D',
  industry: 'lifestyle',
  template: 'pop',
  tagline: 'Stuff, in colour.',
  hero: {
    eyebrow: 'SS·26 Drop',
    headline: 'Made\nin <em>Colour.</em>',
    lede: 'Five products. Five universes. Scroll to meet the family.',
    cta: 'See the collection',
  },
  manifesto: {
    title: 'Loud.\nPlayful.\nOn time.',
    body: 'One rule: every product earns its colour or it does not ship.',
  },
};

export const products = [
  {
    id: 'volt', name: 'VOLT', tag: 'SS·26 / 01', price: '$95',
    shape: 'cylinder', framing: 'square', material: 'plastic',
    colorA: '#39ff14', colorB: '#0a0a0a', accent: '#ff1493', mood: 'pop', stripeLink: null,
    variants: [
      { sku: 'VOLT-NEON',   name: 'Neon',   colorA: '#39ff14', colorB: '#0a0a0a', accent: '#ff1493' },
      { sku: 'VOLT-CYAN',   name: 'Cyan',   colorA: '#00ffff', colorB: '#0a0a0a', accent: '#ff1493' },
      { sku: 'VOLT-VIOLET', name: 'Violet', colorA: '#bf00ff', colorB: '#fff8ec', accent: '#39ff14' },
    ],
  },
  { id: 'flare', name: 'FLARE', tag: 'SS·26 / 02', price: '$120', shape: 'sphere', framing: 'square', material: 'chrome', colorA: '#ff1493', colorB: '#fff8ec', accent: '#00ffff', mood: 'sun' },
  { id: 'haze',  name: 'HAZE',  tag: 'SS·26 / 03', price: '$140', shape: 'torus', framing: 'landscape', material: 'metal', colorA: '#bf00ff', colorB: '#ffaa00', accent: '#39ff14', mood: 'storm' },
  { id: 'drift', name: 'DRIFT', tag: 'SS·26 / 04', price: '$110', shape: 'capsule', framing: 'portrait', material: 'porcelain', colorA: '#00ffff', colorB: '#0a0a0a', accent: '#bf00ff', mood: 'mint' },
  { id: 'ember', name: 'EMBER', tag: 'SS·26 / 05', price: '$160', shape: 'bottle', framing: 'tall', material: 'glass', colorA: '#ffaa00', colorB: '#0a0a0a', accent: '#00ffff', mood: 'midnight' },
];

export const moodTints = {
  pop: '#fff8ec', sun: '#ffe9d4', storm: '#f0e6ff', mint: '#e0fff4', midnight: '#1a1a2e',
};
